const getFileSizeText = (size, farsi = false) => {
  if (!size) return ""

  const oneKiloByte = 1000

  const oneMegaByte = 1000000

  const oneGigaByte = 1000000000

  let s = Number(Math.abs(size))

  if (s < oneKiloByte) return `${s}${farsi ? " بایت" : "B"}`

  if (s < oneMegaByte) return `${Number(s / oneKiloByte).toFixed(1)}${farsi ? " کیلوبایت" : "KB"}`

  if (s < oneGigaByte) return `${Number(s / oneMegaByte).toFixed(1)}${farsi ? " مگابایت" : "MB"}`

  return `${Number(s / oneGigaByte).toFixed(1)}${farsi ? " گیگابایت" : "GB"}`
}

export default getFileSizeText